import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const RepeatIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="m5.17 1.47 2.64 2.64a.75.75 0 0 1 0 1.06L5.17 7.81a.75.75 0 0 1-1.06-1.06l1.36-1.36H4.332c-1.392 0-2.583 1.196-2.583 2.75 0 1.553 1.19 2.75 2.583 2.75a.75.75 0 0 1 0 1.5C2.044 12.39.25 10.452.25 8.14c0-2.313 1.794-4.25 4.083-4.25H5.47L4.11 2.53A.75.75 0 0 1 5.17 1.47Zm6.497 2.42a.75.75 0 0 0 0 1.5c1.392 0 2.583 1.196 2.583 2.75 0 1.553-1.19 2.75-2.583 2.75h-.874l1.36-1.36a.75.75 0 1 0-1.061-1.06l-2.64 2.64a.75.75 0 0 0 0 1.06l2.64 2.64a.75.75 0 0 0 1.06-1.06l-1.36-1.36h.875c2.289 0 4.083-1.938 4.083-4.25 0-2.313-1.794-4.25-4.083-4.25Z"/>
    </svg>
);
RepeatIcon.displayName = 'RepeatIcon';
export default RepeatIcon;
